<div class="w-full">
	<app-modal-alert
		*ngIf="openAlert"
		[value]="valueModalDelete"
		[nameModal]="nameModal"
		[elementsDelete]="elementsDelete"
		(closeModalAlert)="closeModalAlert($event)"
	></app-modal-alert>
	<layout-table
		(action)="buttonAction($event)"
		[filterList]="filterList"
		[viewDelete]="viewDelete"
		(filterValues)="getFilterValues($event)"
		(isLoading)="refreshData($event)"
		[heigth]="heigthTable"
		[widthFilter]="414"
		[optionsFilter]="columnsFilter"
		(filterSelected)="filterSelected($event)"
	>
		<app-pagination
			slot="end"
			class="hidden md:block"
			[info]="pagination"
			(emitNavigationPag)="emitNavigation($event)"
		>
		</app-pagination>
		<ngx-datatable
			*ngIf="!isLoading"
			table
			[columns]="columns"
			[rows]="userTableRow || []"
			class="mg-table fullscreen"
			[columnMode]="modeColum"
			[headerHeight]="50"
			[footerHeight]="0"
			[rowHeight]="50"
			[limit]="10"
			[scrollbarH]="true"
			[scrollbarV]="true"
			[selectionType]="selectionType.checkbox"
			(select)="onSelect($event)"
			[sorts]="[{ prop: 'fullName', dir: 'asc' }]"
		>
			<ngx-datatable-column
				[width]="50"
				[sortable]="false"
				[canAutoResize]="false"
				[draggable]="false"
				[resizeable]="false"
			>
				<ng-template
					ngx-datatable-header-template
					let-value="value"
					let-allRowsSelected="allRowsSelected"
					let-selectFn="selectFn"
				>
					<div class="mng-checkbox">
						<input
							type="checkbox"
							[checked]="allRowsSelected"
							(change)="selectFn(!allRowsSelected)"
						/>
						<span class="checkbox"></span>
					</div>
				</ng-template>
				<ng-template
					ngx-datatable-cell-template
					let-value="value"
					let-isSelected="isSelected"
					let-onCheckboxChangeFn="onCheckboxChangeFn"
				>
					<div class="mng-checkbox">
						<input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
						<span class="checkbox"></span>
					</div>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="Username" [headerClass]="'text-complementary-color-a font-bold'">
				<ng-template
					ngx-datatable-header-template
					let-value="value"
					let-allRowsSelected="allRowsSelected"
					let-selectFn="selectFn"
				>
					<span> {{ translateUsers.table!.username || '' }}</span>
				</ng-template>
				<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
					<span
						[title]="row.username"
						[ngClass]="{ username: row.username.includes('Administrador') }"
					>
						{{ row.username }}
					</span>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column
				[headerClass]="'text-complementary-color-a font-bold'"
				[name]="columnsElement.name"
				*ngFor="let columnsElement of columns"
			>
				<ng-template
					ngx-datatable-header-template
					let-value="value"
					let-allRowsSelected="allRowsSelected"
					let-selectFn="selectFn"
				>
					<span> {{ columnsElement.label || '' }} </span>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="Phone" [headerClass]="'text-complementary-color-a font-bold'">
				<ng-template
					ngx-datatable-header-template
					let-value="value"
					let-allRowsSelected="allRowsSelected"
					let-selectFn="selectFn"
				>
					<span> {{ translateUsers.table!.phone || '' }} </span>
				</ng-template>
				<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
					<span [title]="row.phone">
						{{ row.phone }}
					</span>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column
				name="Status"
				*ngIf="group.sk"
				cellClass="status"
				[headerClass]="'text-complementary-color-a font-bold'"
			>
				<ng-template
					ngx-datatable-header-template
					let-value="value"
					let-allRowsSelected="allRowsSelected"
					let-selectFn="selectFn"
				>
					<span> {{ translateUsers.table!.status || '' }} </span>
				</ng-template>
				<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
					<span
						class="px-3 py-1 rounded-lg text-center w-full"
						[ngStyle]="{ background: row.groups[0].color }"
						[title]="row.groups[0].status"
					>
						<p class="opacity-70 truncate">{{ row.groups[0].status }}</p>
					</span>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column name="Actions" [headerClass]="'text-complementary-color-a font-bold'">
				<ng-template
					ngx-datatable-header-template
					let-value="value"
					let-allRowsSelected="allRowsSelected"
					let-selectFn="selectFn"
				>
					<span> {{ translateUsers.table!.actions || '' }} </span>
				</ng-template>
				<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
					<div class="w-full flex justify-center">
						<app-actions-table
							[optionsTable]="
								row.username === 'Administrador' || !viewDelete ? optionsTableUser : optionsTable
							"
							[value]="row"
							(action)="actions($event)"
						></app-actions-table>
					</div>
				</ng-template>
			</ngx-datatable-column>
		</ngx-datatable>
		<app-loading-spinner loading *ngIf="isLoading"></app-loading-spinner>
	</layout-table>
</div>
